/* eslint-disable no-restricted-imports */
/* eslint-disable react/forbid-component-props */
import { productCardContainerSX } from '@/components/blocks/DpLibrary/DpProductCardSearch/styles/container';
import { productCardImagerSX } from '@/components/blocks/DpLibrary/DpProductCardSearch/styles/image';
import {
	productCardDescriptionSX,
	productCardDiscountSX,
	productCardPriceSX,
	productCardTitleSX,
} from '@/components/blocks/DpLibrary/DpProductCardSearch/styles/typography';
import { Img } from '@/components/blocks/MaterialImage';
import { RenderProductImg } from '@/components/blocks/RenderProductImg';
import { ProductRibbons } from '@/components/blocks/Ribbons';
import { Ribbon } from '@/data/types/Product';
import { mergeRibbonsForProduct } from '@/utils/mergeRibbonsForProduct';
import { Box, Grid, Typography } from '@mui/material';
import Link from 'next/link';

type ProductType = 'electronic' | '';

export const DpProductCardSearch = ({
	title: title,
	image: image,
	discount: discount,
	price: price,
	type: type,
	seo: seo,
	ribbons = [],
}: {
	title: string;
	category: string;
	image: string;
	discount?: string;
	price: string;
	colors?: string[];
	type?: ProductType;
	seo?: string;
	ribbons?: Ribbon[];
}) => {
	// const [selected, setSelected] = useState<number>(0);
	const sxPrice = productCardPriceSX(discount !== undefined);

	// const handleSelected = (index: number) => setSelected(index);
	const sortedRibbons = mergeRibbonsForProduct(ribbons);

	return (
		<Grid className="product-card-container" sx={productCardContainerSX}>
			<Link className="product-card-linkable" href={`${seo}`} draggable={false}>
				<Box className="product-card-content" sx={{ position: 'relative' }}>
					<RenderProductImg
						fullImageRaw={image}
						render={(image) => (
							<Img
								className="product-card-image"
								src={image}
								draggable={false}
								alt={title}
								sx={productCardImagerSX}
							/>
						)}
					/>
					<ProductRibbons ribbons={sortedRibbons} />
				</Box>
			</Link>
			<Grid padding={type === 'electronic' ? '0 0px 0px 0px' : '0px 0px 0px 0px'}>
				{type === 'electronic' ? (
					<>
						<Typography sx={productCardTitleSX}>{title}</Typography>
						<Typography sx={productCardDescriptionSX}>{'Con dpvale desde:'}</Typography>
						<Typography sx={productCardDiscountSX}>{'$871 quincenal'}</Typography>
						<Typography sx={productCardDescriptionSX}>
							{'$14,899 en 14 quincenas* De contado: $14,899'}
						</Typography>
					</>
				) : (
					<Grid container display={'flex'} flexDirection={'column'}>
						<Grid item>
							<Typography sx={productCardTitleSX}>{title}</Typography>
						</Grid>
						{/* <Grid item>
							<Typography sx={productCardCategorySX}>{category}</Typography>
						</Grid> */}
						<Grid item display={'flex'} flexDirection={'row'} mt={'6px'}>
							{discount ? <Typography sx={productCardDiscountSX}>{discount}</Typography> : null}
							<Typography sx={sxPrice}>{price}</Typography>
						</Grid>
					</Grid>
				)}
			</Grid>
		</Grid>
	);
};
